import { MimeToExtension } from './mime-to-extension/mime-to-extension.pipe';
import { IsValidEmailPipe } from './is-valid-email/is-valid-email.pipe';
import { TimeAgoPipe } from './time-ago.pipe';

export { MimeToExtension, IsValidEmailPipe, TimeAgoPipe };

export default [MimeToExtension, IsValidEmailPipe, TimeAgoPipe];
